import asyncActionTypes from '../actions/types';
import PNRTCReservationUIModel from '../../api-wrapper/ui-models/pnr-tc-reservation/pnr-tc-reservation';

const initialState = {
  responseCheckInReservation: {},
  errorReservation: null,
  loadingCheckInReservation: false,
  requestCheckInReservation: {},
};

const checkinReservation = ( state = initialState, action ) => {
  switch (action.type) {
    case asyncActionTypes.RETRIEVE_CHECKIN_RESERVATION.START:
      return {
        ...state,
        loadingCheckInReservation: true,
        requestCheckInReservation: action,
      };
    case asyncActionTypes.RETRIEVE_CHECKIN_RESERVATION.SUCCESS:
      const payload = new PNRTCReservationUIModel(action?.payload);
      return {
        ...state,
        loadingCheckInReservation: false,
        errorReservation: action.payload.error ? true : false,
        responseCheckInReservation: {
          ...payload,
        },
      };
    case asyncActionTypes.RETRIEVE_CHECKIN_RESERVATION.FAIL:
      return {
        ...state,
        loadingCheckInReservation: false,
        errorReservation: true,
        responseCheckInReservation: {
          ...action.payload,
        },
      };
    default:
      return state;
  }
};

export default checkinReservation;